import React, { Component } from 'react';
import "HELPDESK/Components/DemoDetails/demodetails.css";
import config from 'config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import HtmlParser from 'react-html-parser';
class DemoDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET CLIENT DEMO LIST
            demoListFetching: false,
            demoList: {},
            pageIndex: 1,
            limit: 50,
            offset: 0,
            demoCount: 0,
            filterDate: '',
            searchTerm:'',
            
            // VARIABLES TO SELECT DEMO
            selectedDemoIds: [],

            // VARIABLES TO GET SUBSCRIPTION WISE MODULE LIST
            subscriptionModuleList: {},

            // VARIABLES TO GET SPOC DETAILS
            spocDetails: {},
            spocId: '',
            spocName: '',

            // VARIABLES TO GET ATTENDEE LIST
            attendeeFetching: false,
            attendeeList: {},

            // VARIABLES TO GET TIME SLOT
            timeSlot: {},

            // VARIABLES TO SCHEDULE DEMO
            scheduleDemo: false,
            schedulingDemo: false,
            meetingName: '',
            meetingNameWarning: '',
            selectModules: false,
            tempSelectedModules: {},
            selectedModules: {},
            moduleWarning: '',
            selectAttendees: false,
            tempSelectedAttendees: {},
            selectedAttendees: {},
            attendeeWarning: '',
            meetingDate: '',
            meetingDateWarning: '',
            selectedTimeSlotId: '',
            selectedTimeSlot: '',
            timeSlotWarning: '',
            stepUniqueId: '',

            // VARIABLES TO UPDATE DEMO
            demoUpdateMode: false,
            demoUniqueId: '',
            selectedDemo:"",
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET DEMO LIST
        this.apiCallToGetDemoList();
        
        // METHOD CALLED TO GET ATTENDEE LIST
        this.apiCallToGetAttendeeList();
        
        // METHOD CALLED TO GET SPOC DETAILS
        this.apiCallToGetSPOCDetails();

        // METHOD CALLED TO GET SUBSCRIPTION MODULE
        this.apiCallToSubscriptionModuleList();
    }

    // API CALL TO GET CLIENT DEMO LIST
    apiCallToGetDemoList = async () => {
        this.setState({
            demoListFetching: true
        });

        let requestData = {
            "page_index": this.state.pageIndex,
            "limit": this.state.limit,
            "demoDate": this.state.filterDate,
            "iid": config.institute_id,
            "vm_team_attendees": '',
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMClientDemoList',
            requestData,
            '/api/projectManagement/ClientDemo/ClientDemo.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetDemoList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    demoListFetching: false,
                    demoList: apiResult,
                    demoCount: jsonResponse.APIResult.totalCount
                });
            } else {
                this.setState({
                    demoListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting client demo list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET ATTENDEE LIST
    apiCallToGetAttendeeList = async () => {
        this.setState({
            attendeeFetching: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "department":'',
            "search": this.state.searchTerm
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getEmployeeDetails',
            requestData,
            '/api/employee/employee.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAttendeeList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    attendeeFetching: false,
                    attendeeList: apiResult
                });
            } else {
                this.setState({
                    attendeeFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting attendee list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET SPOC DETAILS
    apiCallToGetSPOCDetails = async () => {
        let requestData = {
            "institute_id": config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMIndividualInstituteSpocList',
            requestData,
            '/api/projectManagement/client/spoc.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetSPOCDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if(Object.keys(apiResult).length > 0) {
                    Object.values(apiResult).map(spoc => {
                        
                        if(spoc.type == "primary spoc")
                        {
                            this.setState({
                                spocId: spoc.employee_id,
                                spocName: spoc.spoc_name
                            });
                        }
                        
                    });
                }

                this.setState({
                    spocDetails: apiResult
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting spoc details. Please try again later.'
                });
            }
        }
    }

    // API METHOD CALL TO GET SUBSCRIPTION MODULE LIST
    apiCallToSubscriptionModuleList = async () => {
        let requestData = {
            "iid": config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskModuleList',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToSubscriptionModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    subscriptionModuleList: apiResult,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting subscription module list. Please try again later.'
                });
            }
        }
    }

    // METHOD TO GET FILTER DEMO DATE
    getFilterDemoDate = (e) => {
        this.setState({
            filterDate: e.target.value
        });
    }

    // METHOD TO GET DEMO LIST BY DATE
    getDemoListByDate = (e) => {
        if(e.charCode == 13) {
            this.apiCallToGetDemoList();
        }
    }

    // METHOD TO FOMRAT DATE
    formatDate = (d) =>{
        var date = new Date(d);

        if (isNaN(date.getTime())) {
            return "";
        }else{  
            var month = new Array();
            month[0] = "January";
            month[1] = "February";
            month[2] = "March";
            month[3] = "April";
            month[4] = "May";
            month[5] = "June";
            month[6] = "July";
            month[7] = "August";
            month[8] = "September";
            month[9] = "October";
            month[10] = "November";
            month[11] = "December";

            let day = date.getDate();
            
            if(day < 10) {
                day = "0"+day;
            }
            return day  + " " +month[date.getMonth()] + ", " + date.getFullYear();
        }       
    }

    // METHOD TO RETURN SCHEDULE DEMO SLIDER
    returnScheduleDemo = () => {
        return(
            <div id="scheduleDemoSlider" style={{ display: this.state.scheduleDemo ? 'flex' : 'none' }}>
                <div id="scheduleDemoDataContainer">
                    <div id="scheduleDemoHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeScheduleDemo()} style={{ cursor: "pointer" }} />
                        <h5 className="col-11">Schedule Demo</h5>
                    </div>
                    <div id="scheduleDemoBody" className="col-md-12">
                        <div className="meetingName">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Meeting Name {!(this.state.demoType == 'onboarding') && <span style={{ color: 'red' }}>*</span>}</label>
                            {
                                this.state.demoType == 'onboarding' ?
                                    <p style={{ fontSize: 14 }}>{this.state.meetingName}</p>
                                :
                                    <>
                                        <input
                                            type="text"
                                            placeholder="Enter Meeting Name"
                                            value={this.state.meetingName}
                                            className="form-control scheduleDemoInput"
                                            onChange={(e) => this.getMeetingName(e)}
                                        />
                                        <p className="text-danger" style={{ fontSize: 14 }}>{this.state.meetingNameWarning}</p>
                                    </>
                            }
                        </div>
                        <div className="modules">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">{this.state.demoType == 'onboarding' ? 'Modules' : 'Select Module'} {!(this.state.demoType == 'onboarding') && <span style={{ color: 'red' }}>*</span>}</label>
                            {
                                this.state.demoType == 'onboarding' ?
                                    <p style={{ fontSize: 14 }}>{Object.values(this.state.selectedModules).join(', ')}</p>
                                :
                                    <>
                                        <input
                                            type="text"
                                            placeholder="Click here to select modules(s)"
                                            className="form-control scheduleDemoInput"
                                            readOnly
                                            onClick={() => this.setState({ selectModules: true })}
                                        />
                                        {
                                            Object.keys(this.state.selectedModules).length > 0 &&
                                                Object.keys(this.state.selectedModules).map(moduleId => {
                                                    return(
                                                        <div className="selected-attendee">
                                                            <p style={{ fontSize: 14 }}>
                                                                {this.state.selectedModules[moduleId]}
                                                                <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeModule(moduleId)} />
                                                            </p>
                                                        </div>
                                                    );
                                                })
                                        }
                                        <p className="text-danger" style={{ fontSize: 14 }}>{this.state.moduleWarning}</p>
                                    </>
                            }
                        </div>
                        <div className="selectAttendees">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Select Attendee(s) <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="text"
                                placeholder="Click here to select attendee(s)"
                                className="form-control scheduleDemoInput"
                                readOnly
                                onClick={() => this.setState({ selectAttendees: true })}
                            />
                            {
                                Object.keys(this.state.selectedAttendees).length > 0 &&
                                    Object.keys(this.state.selectedAttendees).map(employeeId => {
                                        return(
                                            <div className="selected-attendee">
                                                <p style={{ fontSize: 14 }}>
                                                    {this.state.selectedAttendees[employeeId]}
                                                    <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeAttendee(employeeId)} />
                                                </p>
                                            </div>
                                        );
                                    })
                            }
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.attendeeWarning}</p>
                        </div>
                        <div className="meetingDate">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Date <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="date"
                                className="form-control scheduleDemoInput"
                                value={this.state.meetingDate}
                                onChange={(e) => this.getMeetingDate(e)}
                            />
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.meetingDateWarning}</p>
                        </div>
                        <div className="meetingSlot">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Time Slot <span style={{ color: 'red' }}>*</span></label>
                            <select
                                className="form-control scheduleDemoInput"
                                disabled={this.state.meetingDate == ''}
                                value={this.state.selectedTimeSlotId}
                                onChange={(e) => this.getMeetingSlot(e)}
                            >
                                <option value="">Select Time Slot</option>
                                {
                                    (this.state.timeSlot[this.state.meetingDate] != undefined) && (Object.keys(this.state.timeSlot).length > 0 && this.state.meetingDate.length > 0) &&
                                        Object.values(this.state.timeSlot[this.state.meetingDate]).map(slot => {
                                            return(
                                                <option key={slot.uniqueid} value={slot.uniqueid}>
                                                    {slot.start_time} - {slot.end_time}
                                                </option>
                                            );
                                        })
                                }
                            </select>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.timeSlotWarning}</p>
                        </div>
                    </div>
                    <div id="scheduleDemoFooter" style={{ marginBottom: 10 }}>
                        {
                            this.state.schedulingDemo &&
                                <ButtonLoader />
                        }
                        <button className="btn btn-primary" onClick={() => this.validateDemoDetails()} disabled={this.state.schedulingDemo}>{this.state.demoUpdateMode ? 'Update' : 'Schedule'}</button>
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeScheduleDemo()}>Cancel</button>
                    </div>
                </div>
            </div >
        );
    }

    // METHOD TO GET MEETING NAME
    getMeetingName = (e) => {
        this.setState({
            meetingName: e.target.value
        });

        if(e.target.value.length < 1) {
            this.setState({
                meetingNameWarning: 'Meeting name cannot be empty.'
            });
        }else {
            this.setState({
                meetingNameWarning: ''
            });
        }
    }

    // METHOD TO RETURN SELECT MODULES MODAL
    returnSelectModules = () => {
        return(
            <div className={this.state.selectModules ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'user']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Select Modules</h3>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeSelectModules()}/>
                        </div>
                        <div className="modal-body selectModules-body">
                            <div className="moduleList">
                                {
                                    this.state.modulesFetching ?
                                        <ButtonLoader />
                                    :
                                        Object.keys(this.state.subscriptionModuleList).length > 0 ?
                                            Object.values(this.state.subscriptionModuleList).map(module => {
                                                
                                                        return(
                                                            <div className="module">
                                                                <input
                                                                    type='checkbox'
                                                                    style={{ marginRight: 5 }}
                                                                    checked={this.state.tempSelectedModules[module.moduleId] != undefined}
                                                                    onClick={(e) => this.selectModuleDetails(e, module)}
                                                                />
                                                                <span>{module.module_name}</span>
                                                            </div>
                                                        );
                                                    })
                                
                                    :<p>No module details found.</p>
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn primary-button" onClick={() => this.confirmModuleSelection()}>Select</button>
                            <button className="btn outline-button" onClick={() => this.closeSelectModules()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
    // METHOD TO SELECT MODULES DETAILS
    selectModuleDetails = (e, module) => {
        let tempSelectedModules = this.state.tempSelectedModules;
        if(e.target.checked) {
            if(tempSelectedModules[module.moduleId] == undefined) {
                tempSelectedModules[module.moduleId] = '';
            }
            tempSelectedModules[module.moduleId] = module.module_name;
        }else {
            delete tempSelectedModules[module.moduleId];
        }

        this.setState({
            tempSelectedModules
        });
    }

    // METHOD TO CONFIRM MODULE SELECTION
    confirmModuleSelection = () => {
        let selectedModules = this.state.selectedModules;
        if(Object.keys(this.state.tempSelectedModules).length > 0) {
            Object.keys(this.state.tempSelectedModules).map(moduleId => {
                if(selectedModules[moduleId] == undefined) {
                    selectedModules[moduleId] = '';
                }
                selectedModules[moduleId] = this.state.tempSelectedModules[moduleId];
            });
        }else {
            selectedModules = {};
        }

        if(Object.keys(selectedModules).length > 0) {
            this.setState({
                moduleWarning: ''
            });
        }else {
            this.setState({
                moduleWarning: 'Please select module(s).'
            });
        }

        this.setState({
            selectModules: false,
            selectedModules
        });
    }

    // METHOD TO CLOSE SELECT MODULES MODAL
    closeSelectModules = () => {
        let tempSelectedModules = this.state.tempSelectedModules;
        if(Object.keys(this.state.selectedModules).length > 0) {
            Object.keys(this.state.selectedModules).map(moduleId => {
                if(tempSelectedModules[moduleId] == undefined) {
                    tempSelectedModules[moduleId] = '';
                }
                tempSelectedModules[moduleId] = this.state.selectedModules[moduleId];
            });
        }else {
            tempSelectedModules = {};
        }
        this.setState({
            selectModules: false,
            tempSelectedModules,
        });
    }

    // METHOD TO REMOVE SELECTED MODULES
    removeModule = (moduleId) => {
        let selectedModules = this.state.selectedModules;
        let tempSelectedModules = this.state.tempSelectedModules;
        delete selectedModules[moduleId];
        delete tempSelectedModules[moduleId];
        this.setState({
            selectedModules,
            tempSelectedModules
        });
    }

    // METHOD TO RETURN SELECT ATTENDEES MODAL
    returnSelectAttendees = () => {
        return(
            <div className={this.state.selectAttendees ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'user']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Select Attendees</h3>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeSelectAttendees()}/>
                        </div>
                        <div className="modal-body selectAttendees-body">
                            <div className="searchName">
                                <FontAwesomeIcon icon={['fas', 'search']} color="#495057" className="search-icon" />
                                <input
                                    type="text"
                                    className="form-control searchInput"
                                    placeholder="Search Attendee" 
                                    onChange={(e)=>this.setState({ searchTerm: e.target.value })} 
                                    value={this.state.searchTerm}
                                    onKeyPress={(e) => this.searchAttendee(e)}
                                />
                            </div>
                            <p className="info-msg">Press enter to search.</p>
                            <div className="employeeList">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th style={{ padding: 5 }}></th>
                                            <th style={{ padding: 5 }}>Sr. No.</th>
                                            <th style={{ padding: 5 }}>Designation</th>
                                            <th style={{ padding: 5 }}>First Name</th>
                                            <th style={{ padding: 5 }}>Last Name</th>
                                            <th style={{ padding: 5 }}>Role</th>
                                            <th style={{ padding: 5 }}>Email Id</th>
                                            <th style={{ padding: 5 }}>Mobile Number</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.attendeeFetching ?
                                                <tr>
                                                    <td style={{ padding: 5 }} colSpan={8}>
                                                        <ButtonLoader />
                                                    </td>
                                                </tr>
                                            :
                                                Object.keys(this.state.attendeeList).length > 0 ?
                                                    Object.values(this.state.attendeeList).map((attendee, attendeeIndex) => {
                                                        return(
                                                            <tr key={attendee.FacultyId}>
                                                                <td style={{ padding: 5 }}>
                                                                    <input
                                                                        type='checkbox'
                                                                        name="employee"
                                                                        style={{ marginRight: 5 }}                                                                        
                                                                        checked={this.state.tempSelectedAttendees[attendee.FacultyId] != undefined}
                                                                        onClick={(e) => this.selectAttendeeDetails(e, attendee)}
                                                                    />
                                                                </td>
                                                                <td style ={{ padding: 5 }}>{attendeeIndex + 1}.</td>
                                                                <td style ={{ padding: 5 }}>{attendee.designation}</td>
                                                                <td style ={{ padding: 5 }}>{attendee.FirstName}</td>
                                                                <td style ={{ padding: 5 }}>
                                                                    <span>{attendee.LastName} |</span>
                                                                    <span  style={{marginLeft:5 ,color:attendee.status == "active" ? " #219653" :" #eb5757"}}>{attendee.status}</span>                                                                    
                                                                </td>                                                                
                                                                <td style ={{ padding: 5 }}>{attendee.employeeRole}</td>
                                                                <td style ={{ padding: 5 }}>{attendee.email_id}</td>
                                                                <td style ={{ padding: 5 }}>{attendee.mobile_no}</td>
                                                            </tr>
                                                        );
                                                    })
                                                :
                                                    <tr>
                                                        <td style={{ padding: 5 }}>No attendee found.</td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn primary-button" onClick={() => this.confirmAttendeeSelection()}>Select</button>
                            <button className="btn outline-button" onClick={() => this.closeSelectAttendees()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO SEARCH ATTENDEE
    searchAttendee = (e) => {
        if(e.charCode == 13) {
            this.apiCallToGetAttendeeList();
        }
    }
    
    // METHOD TO SELECT ATTENDEES DETAILS
    selectAttendeeDetails = (e, attendee) => {
        let tempSelectedAttendees = this.state.tempSelectedAttendees;
        if(e.target.checked) {
            if(tempSelectedAttendees[attendee.FacultyId] == undefined) {
                tempSelectedAttendees[attendee.FacultyId] = '';
            }
            tempSelectedAttendees[attendee.FacultyId] = attendee.FirstName + ' ' + attendee.LastName;
        }else {
            delete tempSelectedAttendees[attendee.FacultyId];
        }

        this.setState({
            tempSelectedAttendees
        });
    }

    // METHOD TO CONFIRM ATTENDEE SELECTION
    confirmAttendeeSelection = () => {
        let selectedAttendees = this.state.selectedAttendees;
        if(Object.keys(this.state.tempSelectedAttendees).length > 0) {
            Object.keys(this.state.tempSelectedAttendees).map(employeeId => {
                if(selectedAttendees[employeeId] == undefined) {
                    selectedAttendees[employeeId] = '';
                }
                selectedAttendees[employeeId] = this.state.tempSelectedAttendees[employeeId];
            });
        }else {
            selectedAttendees = {};
        }

        if(Object.keys(selectedAttendees).length > 0) {
            this.setState({
                attendeeWarning: ''
            });
        }else {
            this.setState({
                attendeeWarning: 'Please select attendee(s).'
            });
        }

        this.setState({
            selectAttendees: false,
            selectedAttendees
        });
    }

    // METHOD TO CLOSE SELECT ATTENDEES MODAL
    closeSelectAttendees = () => {
        let tempSelectedAttendees = this.state.tempSelectedAttendees;
        if(Object.keys(this.state.selectedAttendees).length > 0) {
            Object.keys(this.state.selectedAttendees).map(employeeId => {
                if(tempSelectedAttendees[employeeId] == undefined) {
                    tempSelectedAttendees[employeeId] = '';
                }
                tempSelectedAttendees[employeeId] = this.state.selectedAttendees[employeeId];
            });
        }else {
            tempSelectedAttendees = {};
        }
        this.setState({
            selectAttendees: false,
            tempSelectedAttendees,
        });
    }

    // METHOD TO REMOVE SELECTED ATTENDEES
    removeAttendee = (employeeId) => {
        let selectedAttendees = this.state.selectedAttendees;
        let tempSelectedAttendees = this.state.tempSelectedAttendees;
        delete selectedAttendees[employeeId];
        delete tempSelectedAttendees[employeeId];
        this.setState({
            selectedAttendees,
            tempSelectedAttendees
        });
    }

    // METHOD TO GET MEETING DATE
    getMeetingDate = (e) => {
        let meetingDate = this.state.meetingDate;
        meetingDate = e.target.value;

        if(e.target.value.length < 1) {
            this.setState({
                meetingDate,
                selectedTimeSlotId: '',
                selectedTimeSlot: '',
                meetingDateWarning: 'Please select meeting date.'
            });
        }else {
            this.setState({
                meetingDate,
                meetingDateWarning: ''
            }, () => {
                this.apiCallToGetTimeSlot();
            });
        }
    }

    // API CALL METHOD TO GET TIME SLOT
    apiCallToGetTimeSlot = async () => {
        let requestData = {
            "emp_id": this.state.spocId,
            "start_date": this.state.meetingDate,
            "end_date": this.state.meetingDate,
            "isAvailable": this.state.demoUpdateMode ? '' : "true"
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMTimeSlotList',
            requestData,
            '/api/projectManagement/timeSlot/timeSlot.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetTimeSlot()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    timeSlot: apiResult
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting available time slots. Please try again later.'
                });
            }
        }
    }

    // METHOD TO GET MEETING SLOT
    getMeetingSlot = (e) => {
        this.setState({
            selectedTimeSlotId: e.target.value
        });

        if(e.target.value.length < 1) {
            this.setState({
                timeSlotWarning: 'Please select meeting slot.',
                selectedTimeSlot: ''
            });
        }else {
            this.setState({
                timeSlotWarning: '',
                selectedTimeSlot: e.target.selectedOptions[0].text
            });
        }
    }

    // METHOD TO VALIDATE DEMO DETAILS
    validateDemoDetails = () => {
        let validData = true;

        if(this.state.meetingName.length < 1) {
            this.setState({
                meetingNameWarning: 'Meeting name cannot be empty.'
            });
            validData = false;
        }

        if(Object.keys(this.state.selectedModules).length < 1) {
            this.setState({
                moduleWarning: 'Please select module.'
            });
            validData = false;
        }
        
        if(Object.keys(this.state.selectedAttendees).length < 1) {
            this.setState({
                attendeeWarning: 'Please select attendee(s).'
            });
            validData = false;
        }

        if(this.state.meetingDate.length < 1) {
            this.setState({
                meetingDateWarning: 'Please select meeting date.'
            });
            validData = false;
        }

        if(this.state.selectedTimeSlotId.length < 1) {
            this.setState({
                timeSlotWarning: 'Please select meeting slot.'
            });
            validData = false;
        }

        if(validData) {
            if(this.state.demoUpdateMode) {
                // METHOD CALLED TO UPDATE DEMO
                this.apiCallToUpdateDemo();
            }else {
                // METHOD CALLED TO SCHEDULE DEMO
                this.apiCallToScheduleDemo();
            }
        }
    }

    // API CALL METHOD TO SCHEDULE DEMO
    apiCallToScheduleDemo = async () => {
        this.setState({
            schedulingDemo: true
        });

        let requestData = {
            "meeting_name": this.state.meetingName,
            "iid": config.institute_id,
            "meeting_type": "demo",
            "module_id_array": Object.keys(this.state.selectedModules),
            "client_attendees": Object.keys(this.state.selectedAttendees),
            "vm_team_attendees": [this.state.spocId],
            "demo_date": this.state.meetingDate,
            "start_time": this.state.selectedTimeSlot.split(' - ')[0],
            "end_time": this.state.selectedTimeSlot.split(' - ')[1],
            "online_offline_meeting": "Online",
            "facultyId": config.faculty_id,
            "timeslotUID": this.state.selectedTimeSlotId,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'AddClientDemoFromHelpDesk',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToScheduleDemo()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    let demoList = this.state.demoList;
                    if(demoList[apiResult.UID] == undefined) {
                        demoList[apiResult.UID] = {};
                    }

                    demoList[apiResult.UID]['uniqueid'] = apiResult.UID;
                    demoList[apiResult.UID]['clientAttendeesArray'] = Object.keys(this.state.selectedAttendees);
                    demoList[apiResult.UID]['demo_date'] = this.state.meetingDate;
                    demoList[apiResult.UID]['start_time'] = this.state.selectedTimeSlot.split(' - ')[0];
                    demoList[apiResult.UID]['end_time'] = this.state.selectedTimeSlot.split(' - ')[1];
                    demoList[apiResult.UID]['iid'] = config.institute_id;
                    demoList[apiResult.UID]['meeting_type'] = 'demo';
                    demoList[apiResult.UID]['moduleIdArray'] = Object.keys(this.state.selectedModules);
                    demoList[apiResult.UID]['moduleNameArray'] = Object.values(this.state.selectedModules);
                    demoList[apiResult.UID]['online_offline_meeting'] = 'Online';
                    demoList[apiResult.UID]['status'] = 'pending';
                    demoList[apiResult.UID]['timeSlotUID'] = this.state.selectedTimeSlotId;
                    demoList[apiResult.UID]['meeting_name'] = this.state.meetingName;
                    demoList[apiResult.UID]['meeting_link'] = "";
                    demoList[apiResult.UID]['meeting_id'] = "";
                    demoList[apiResult.UID]['meeting_password'] = "";
                    demoList[apiResult.UID]['status'] = "pending";
                    demoList[apiResult.UID]['mom'] = "";
                    demoList[apiResult.UID]['remark'] = "";
                    demoList[apiResult.UID]['mom_attachment'] = [];
                    demoList[apiResult.UID]['client_attendance_array'] = [];
                    demoList[apiResult.UID]["moduleObject"] = this.state.selectedModules;
                    demoList[apiResult.UID]["clientAttendeesObject"] = this.state.selectedAttendees;

                    this.closeScheduleDemo();

                    this.setState({
                        successModal:true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        demoList,
                        schedulingDemo: false
                    });
                }else {
                    this.setState({
                        successModal:true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                        schedulingDemo: false
                    });
                }
            } else {
                this.setState({
                    schedulingDemo: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while scheduling demo. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO UPDATE DEMO
    apiCallToUpdateDemo = async () => {
        this.setState({
            schedulingDemo: true
        });

        let requestData = {
            "meeting_name": this.state.meetingName,
            "iid": config.institute_id,
            "meeting_type": this.state.demoType,
            "module_id_array": Object.keys(this.state.selectedModules),
            "client_attendees": Object.keys(this.state.selectedAttendees),
            "vm_team_attendees": [],
            "demo_date": this.state.meetingDate,
            "start_time": this.state.selectedTimeSlot.split(' - ')[0],
            "end_time": this.state.selectedTimeSlot.split(' - ')[0],
            "online_offline_meeting": this.state.selectedDemo.online_offline_meeting,
            "meeting_link": this.state.selectedDemo.meeting_link,
            "meeting_id": this.state.selectedDemo.meeting_id,
            "meeting_password": this.state.selectedDemo.meeting_password,
            "employee_id": config.faculty_id,
            "DemoId": this.state.demoUniqueId,
            "status":"pending",
            "mom":this.state.selectedDemo.mom,
            "timeslotUID": this.state.selectedTimeSlotId,
            "remark":this.state.selectedDemo.remark,
            "client_attendance":this.state.selectedDemo.client_attendance_array,
            "attachment_key_array":[],
            "removeAttachment":[]
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'UpdateClientDemo',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateDemo()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    let demoList = this.state.demoList;
                    demoList[this.state.demoUniqueId]['uniqueid'] = '';
                    demoList[this.state.demoUniqueId]['clientAttendeesArray'] = Object.keys(this.state.selectedAttendees);
                    demoList[this.state.demoUniqueId]['demo_date'] = this.state.meetingDate;
                    demoList[this.state.demoUniqueId]['start_time'] = this.state.selectedTimeSlot.split(' - ')[0];
                    demoList[this.state.demoUniqueId]['end_time'] = this.state.selectedTimeSlot.split(' - ')[1];
                    demoList[this.state.demoUniqueId]['iid'] = config.institute_id;
                    demoList[this.state.demoUniqueId]['meeting_type'] = 'demo';
                    demoList[this.state.demoUniqueId]['moduleIdArray'] = Object.keys(this.state.selectedModules);
                    demoList[this.state.demoUniqueId]['moduleNameArray'] = Object.values(this.state.selectedModules);
                  
                    demoList[this.state.demoUniqueId]['status'] = 'pending';
                    demoList[this.state.demoUniqueId]['timeSlotUID'] = this.state.selectedTimeSlotId;
                    demoList[this.state.demoUniqueId]['online_offline_meeting'] = this.state.selectedDemo.online_offline_meeting;
                    demoList[this.state.demoUniqueId]['status'] = 'pending';
                    demoList[this.state.demoUniqueId]['timeSlotUID'] = this.state.selectedTimeSlotId;
                    demoList[this.state.demoUniqueId]['meeting_name'] = this.state.meetingName;
                    demoList[this.state.demoUniqueId]['meeting_link'] = this.state.selectedDemo.meeting_link;
                    demoList[this.state.demoUniqueId]['meeting_id'] = this.state.selectedDemo.meeting_id;
                    demoList[this.state.demoUniqueId]['meeting_password'] = this.state.selectedDemo.meeting_password;
                    demoList[this.state.demoUniqueId]['status'] = "pending";
                    demoList[this.state.demoUniqueId]['mom'] = this.state.selectedDemo.mom;
                    demoList[this.state.demoUniqueId]['remark'] = this.state.selectedDemo.remark;
                    demoList[this.state.demoUniqueId]['mom_attachment'] = [];
                    demoList[this.state.demoUniqueId]['client_attendance_array'] = this.state.selectedDemo.client_attendance_array;
                    demoList[this.state.demoUniqueId]["moduleObject"] = this.state.selectedModules;
                    demoList[this.state.demoUniqueId]["clientAttendeesObject"] = this.state.selectedAttendees;

                    this.closeScheduleDemo();

                    this.setState({
                        successModal:true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        demoList,
                        schedulingDemo: false
                    });
                }else {
                    this.setState({
                        successModal:true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                        schedulingDemo: false
                    });
                }
            } else {
                this.setState({
                    schedulingDemo: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while scheduling demo. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE SCHEDULE DEMO
    closeScheduleDemo = () => {
        this.setState({
            scheduleDemo: false,
            schedulingDemo: false,
            meetingName: '',
            meetingNameWarning: '',
            selectModules: false,
            tempSelectedModules: {},
            selectedModules: {},
            selectedModuleArray: [],
            moduleWarning: '',
            selectAttendees: false,
            tempSelectedAttendees: {},
            selectedAttendees: {},
            attendeeWarning: '',
            meetingDate: '',
            meetingDateWarning: '',
            selectedTimeSlotId: '',
            selectedTimeSlot: '',
            timeSlotWarning: '',
            stepUniqueId: '',
            timeSlot: {},
            demoUpdateMode: false
        });
    }

    // VARIABLES TO SELECT ALL DEMOS
    selectAllDemos = (e) => {
        let demoIdSet = new Set();
        if(e.target.checked) {
            if(Object.keys(this.state.demoList).length > 0) {
                Object.keys(this.state.demoList).map(demoId => {
                    demoIdSet.add(parseInt(demoId));
                });
            }
        }else {
            if(Object.keys(this.state.demoList).length > 0) {
                Object.keys(this.state.demoList).map(demoId => {
                    demoIdSet.delete(parseInt(demoId));
                });
            }
        }

        this.setState({
            selectedDemoIds: Array.from(demoIdSet)
        });
    }

    // METHOD TO SELECT SINGLE DEMO
    selectSingleDemo = (demoId) => {
        let selectedDemoIds = this.state.selectedDemoIds;

        if(selectedDemoIds.includes(demoId)) {
            selectedDemoIds = selectedDemoIds.filter(id => id != demoId);
        }else {
            selectedDemoIds.push(demoId);
        }
        
        this.setState({
            selectedDemoIds
        });
    }

    // METHOD TO GET UPDATE DEMO DETAILS
    getUpdateDemoDetails = () => {
        if(this.state.selectedDemoIds.length > 1) {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'Please select only one demo to update details.'
            });
        }else {
            let demo = this.state.demoList[this.state.selectedDemoIds.toString()];
            let clientAttendeesObject = {};
            if(demo.clientAttendeesArray.length > 0) {
                demo.clientAttendeesArray.map(attendeeId => {
                    if(this.state.attendeeList[attendeeId] != undefined)
                    {
                        if(clientAttendeesObject[attendeeId] == undefined) {
                            clientAttendeesObject[attendeeId] = '';
                        }
                        clientAttendeesObject[attendeeId] = this.state.attendeeList[attendeeId].FirstName + ' ' + this.state.attendeeList[attendeeId].LastName;
                    }
                   
                });
            }
            this.setState({
                demoUpdateMode: true,
                demoType: demo.meeting_type,
                demoUniqueId: demo.uniqueid,
                scheduleDemo: true,
                meetingName: demo.meeting_name,
                selectedModules: demo.moduleObject,
                tempSelectedModules: demo.moduleObject,
                selectedAttendees: clientAttendeesObject,
                tempSelectedAttendees: clientAttendeesObject,
                meetingDate: demo.demo_date,
                selectedTimeSlotId: demo.timeslotUID,
                selectedTimeSlot: demo.start_time + ' - ' + demo.end_time,
                selectedDemo : demo
            }, () => {
                this.apiCallToGetTimeSlot();
            });
        }
    }
    
    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    render() {
        return (
            <div className="demoContainer col-md-12">
                <div className="link-header">
                    <FontAwesomeIcon icon={['far', 'arrow-alt-circle-left']} size="lg" style={{ marginRight: 10, cursor: 'pointer' }} onClick={() => this.props.closeLinkDetails()} />
                    <p className="header-text">Module Training</p>
                </div>
                <div className="demo-actions">
                    <div className="searchName col-md-2" style={{ paddingLeft: 0 }}>
                        <input
                            type="date"
                            className="form-control searchInput"
                            value={this.state.filterDate}
                            onChange={(e) => this.getFilterDemoDate(e)}
                            onKeyPress={(e) => this.getDemoListByDate(e)}
                            style={{ fontSize: 14 }}
                        />
                    </div>
                    <div className="addMember-button">
                        <button
                            className="btn primary-button addDemo"
                            onClick={() => this.setState({ scheduleDemo: true })}
                        >
                            Schedule Training
                        </button>
                    </div>
                </div>
                <div className="demoList">
                    <table className="table table-bordered table-responsive" style={{ background:'#FFF' }}>
                        <thead>
                            <tr>
                                <th style={{ padding: 5 }}>
                                    <input
                                        type="checkbox"
                                        checked={Object.keys(this.state.demoList).length > 0 && Object.keys(this.state.demoList).length == this.state.selectedDemoIds.length}
                                        onChange={(e) => this.selectAllDemos(e)}
                                    />
                                </th>
                                <th style={{ padding: 5 }}>Sr. No.</th>
                                <th style={{ padding: 5 }}>Meeting Name</th>
                                <th style={{ padding: 5 }}>Modules</th>
                                <th style={{ padding: 5 }}>Date & Time</th>
                                <th style={{ padding: 5 }}>Attendees</th>
                                <th style={{ padding: 5 }}>Meeting Details</th>
                                <th style={{ padding: 5 }}>Status</th>
                                <th style={{ padding: 5 }}>MoM</th>
                            </tr>
                            {
                                this.state.selectedDemoIds.length > 0 &&
                                    <tr className="active-row">
                                        <th colSpan="9" style={{ padding: 5 }}>
                                            <div className="demoAction-button">
                                                <span className="editDemo" title="Click to update selected demo(s) details" onClick={() => this.getUpdateDemoDetails()}>
                                                    Update
                                                </span>
                                                <span className="cancelDemo" title="Click to cancel selected demo(s)" onClick={() => this.setState({ cancelDemo: true })}>
                                                    Cancel Demo
                                                </span>
                                            </div>
                                        </th>
                                    </tr>
                            }
                        </thead>
                        <tbody>
                            {
                                this.state.demoListFetching ?
                                    <tr>
                                        <td colSpan="9" style={{ padding: 5 }}>
                                            <ButtonLoader />
                                        </td>
                                    </tr>
                                :
                                    Object.keys(this.state.demoList).length > 0 ?
                                        Object.values(this.state.demoList).map((demo, demoIndex) => {
                                            return(
                                                <tr key={demo.uniqueid}>
                                                    <td style={{ padding: 5 }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.selectedDemoIds.includes(demo.uniqueid)}
                                                            onChange={(e) => this.selectSingleDemo(demo.uniqueid)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: 5 }}>{this.state.offset + demoIndex + 1}.</td>
                                                    <td style={{ padding: 5 }}>
                                                        <p className={demo.meeting_type == 'demo' ? 'badge badge-primary meetingBadge' : demo.meeting_type == 'review' ? 'badge badge-warning meetingBadge' : demo.meeting_type == 'onboarding' ? 'badge badge-info meetingBadge' : 'badge badge-secondary meetingBadge'} style={{ textTransform: 'capitalize' }}>{demo.meeting_type}</p>
                                                        <p title={demo.meeting_name} style={{ fontSize: 16, color: '#007bff', cursor: 'pointer' }}>{demo.meeting_name.length > 50 ? demo.meeting_name.substring(0,50) + '...' : demo.meeting_name}</p>
                                                    </td>
                                                    <td title={demo.moduleNameArray.join(', ')} style={{ padding: 5 }}>
                                                        {
                                                            demo.moduleNameArray.length > 0 &&
                                                                <p>{demo.moduleNameArray.join(', ').length > 50 ? demo.moduleNameArray.join(', ').substring(0,50) + '...' : demo.moduleNameArray.join(', ')}</p>
                                                        }
                                                    </td>
                                                    <td style={{ padding: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>{this.formatDate(demo.demo_date)}</p>
                                                        <p>{demo.start_time}-{demo.end_time}</p>
                                                    </td>
                                                    <td style={{ padding: 5 }}>
                                                        <p style={{ color: '#0465AC' }}>{demo.clientAttendeesArray.length}</p>
                                                    </td>
                                                    <td style={{ padding: 5 }}>
                                                        {
                                                            demo.meeting_link.length > 0 &&
                                                                <p><span style={{ fontWeight: 'bold' }}>Link -</span> <a style={{ color: '#007bff' }} href={demo.meeting_link} target='_blank'>{demo.meeting_link}</a></p>
                                                        }
                                                        {
                                                            demo.meeting_id.length > 0 &&
                                                                <p><span style={{ fontWeight: 'bold' }}>ID -</span> <span>{demo.meeting_id}</span></p>
                                                        }
                                                        {
                                                            demo.meeting_password.length > 0 &&
                                                                <p><span style={{ fontWeight: 'bold' }}>Password -</span> <span>{demo.meeting_password}</span></p>
                                                        }
                                                    </td>
                                                    <td style={{ padding: 5 }}>
                                                        <p style={{ color: demo.status == 'pending' ? '#818181' : demo.status == 'in-progress' ? '#F2994A' : demo.status == 'Scheduled' ? '#FF4500' : demo.status == 'cancelled' ? '#EB5757' : demo.status == 'completed' && '#219653', textTransform: 'capitalize', fontWeight: 'bold'}}>
                                                            {demo.status}
                                                        </p>
                                                    </td>
                                                    <td style={{ padding: 5 }}>
                                                        <p style={{ color: '#007bff' }}>{HtmlParser(demo.mom)}</p>
                                                        <p style={{ color: 'rgba(0,0,0,0.6)' }}>
                                                            {
                                                                demo.mom_attachment != null && demo.mom_attachment.length > 0 &&
                                                                    <>
                                                                        <FontAwesomeIcon icon={['fas', 'paperclip']} style={{ marginRight: 5 }} />
                                                                        {demo.mom_attachment.length}
                                                                    </>
                                                            }
                                                        </p>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    :
                                        <tr>
                                            <td colSpan="9" style={{ padding: 5 }}>No demo yet schedule. Please click on 'schedule demo' to schedule demo.</td>
                                        </tr>
                            }
                        </tbody>
                    </table>
                </div>
                {
                    this.returnScheduleDemo()
                }
                {
                    this.returnSelectModules()
                }
                {
                    this.returnSelectAttendees()
                }
                {
                    this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
                <br />
            </div>
        );
    }
}

export default DemoDetails;